export default {
  'TASKTAG' (state) {
    return state.tasktag
  },
  'TASKTAGS' (state) {
    return state.tasktags
  },
  'CONTACTS' (state) {
    return state.contacts
  }
}
